import { EmailAddress } from '@/database/baseTypes';
import { AtSignIcon } from 'lucide-react';
import {
  ContactFieldCollectionData,
  ContactFieldCollection,
} from './ContactFieldCollection';

export const EmailAddressFields = ({
  data,
  onChange,
}: {
  data: ContactFieldCollectionData<EmailAddress>;
  onChange: (data: ContactFieldCollectionData<EmailAddress>) => void;
}) => {
  return (
    <ContactFieldCollection
      collectionName='Email Addresses'
      itemDescriptor='email address'
      textInputLeftSection={<AtSignIcon size={16} />}
      data={data}
      onChange={onChange}
    />
  );
};
